import { render, staticRenderFns } from "./TeacherManageView.vue?vue&type=template&id=246f4080&scoped=true&"
import script from "./TeacherManageView.vue?vue&type=script&lang=js&"
export * from "./TeacherManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246f4080",
  null
  
)

export default component.exports